import React from 'react';
import './Home.css';
import logo from '../../../assets/home_logo.png';

import Sponsors from '../../Sponsors/components/Sponsors';
import About from '../../About/components/About';
import SpeakersFeatured from '../../Speakers/SpeakersContainer';
import CountDown from '../../../components/Countdown/CountDown';

const Home = () => (
    <div id="home-section">
        <div className="container">
            <div className="home">
                <div />
                <div className="home-middle">
                    <div className="home-middle-first-row">
                        <div className="middle-year-left">2019</div>
                        <div className="logo">
                            <img alt="Logo" className="logo-image" src={logo} />
                        </div>
                        <div className="middle-year-right">2019</div>
                    </div>
                    <div className="home-middle-second-row">
                        <div className="info-icons">
                            <i className="fas fa-calendar-alt icon" />
                            <i className="fas fa-map icon" />
                        </div>
                        <div className="info-text">
                            <div>OCTOBER 17 - 18, 2019</div>
                            <div>BRATISLAVA, SLOVAKIA</div>
                        </div>
                    </div>
                    <div className="home-middle-third-row">
                        <CountDown
                            afterDateMessage=""
                            givenDate={new Date('Oct 18 2019 8:30:00')}
                            title=""
                        />
                    </div>
                    <div className="home-middle-third-row">
                        <a
                            className="button is-large"
                            href="https://photos.google.com/share/AF1QipNF-yi2_oVBPS5Hmify3R82P2xFfnUK-cAwajwaBFoXp3Z7hQA0195W9ZFDjOiRaQ?key=c3BUT3BsVUhPU3NHQVJ6cFQ5WHZxUlNnWDFfZVpB"
                            id="cfs-button"
                            rel="noopener noreferrer"
                            target="tab"
                        >
                            PHOTOS
                        </a>
                    </div>
                </div>
                <div className="home-bottom">
                    <div className="home-bottom-left">
                        <span>ACCENTURE CONFERENCE ON</span>
                        <span className="bold-text">EMERGING TECHNOLOGIES</span>
                        <span className="bold-text">AND OPEN SOURCE</span>
                    </div>
                    <div className="home-bottom-right">
                        <div className="info-icons">
                            <i className="fas fa-calendar-alt icon" />
                            <i className="fas fa-map icon" />
                        </div>
                        <div className="info-text">
                            <span>OCTOBER 17 - 18, 2019</span>
                            <span>BRATISLAVA, SLOVAKIA</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <About />
        <SpeakersFeatured />
        <Sponsors />
    </div>
);

export default Home;
